/**
 * Google AI Studio → API key. Üretimde env / gizli değişken kullanın.
 */
export const GEMINI_API_KEY = 'BURAYA_API_KEY_GELECEK';
